import { spenttimeDebug as debug } from '../debug';
import { ITEM_MONITORED_ATTRIBUTE } from '../../constants';
import { stateSwitch } from '../stateSwitch';
var itemsIntersectionObserver = null;
/**
 * The handler that is executed when the visibility of the items changes
 * Can set the state item 'isVisible'
 * @param entries Interface of the Intersection Observer
 */
var itemVisibilityHandler = function (entries) {
    entries.forEach(function (_a) {
        var element = _a.target, isIntersecting = _a.isIntersecting;
        var id = element.getAttribute(stateSwitch.config.items.attributeWithDopId);
        debug({ message: "Element is ".concat(isIntersecting ? '' : 'not ', "visible \"").concat(id, "\"") });
        stateSwitch.setItemState(id, isIntersecting, element);
    });
};
/**
 * Create intersection observer for items
 */
export var createItemsIntersectionObserver = function () {
    if (!stateSwitch.config.items) {
        return;
    }
    var getMargin = function (areaSize) { return Math.round(100 - areaSize * 100); };
    var rMargin = getMargin(stateSwitch.config.items.targetAreaWidth);
    var bMargin = getMargin(stateSwitch.config.items.targetAreaHeight);
    var formatMargin = function (margin) { return (margin > 0 ? "-".concat(margin, "%") : '0%'); };
    var rootMargin = "0% ".concat(formatMargin(rMargin), " ").concat(formatMargin(bMargin), " 0%"); //top, right, bottom, left
    itemsIntersectionObserver = new IntersectionObserver(itemVisibilityHandler, {
        rootMargin: rootMargin,
        threshold: [stateSwitch.config.items.intersectionThreshold],
    });
    debug({
        message: "[items]: rootMargin = \"".concat(rootMargin, "\", threshold = [").concat(stateSwitch.config.items.intersectionThreshold, "]"),
    });
};
/**
 * Adds items visibilitychange event handler
 */
export var addItemsVisibilityEventListeners = function () {
    if (!(itemsIntersectionObserver && stateSwitch.config.items)) {
        return;
    }
    //[data-analytics-spent-time-item]:not([data-analytics-spent-time-item-monitored])
    var selectorWithoutMonitoredItems = stateSwitch.config.items.selector + ":not([".concat(ITEM_MONITORED_ATTRIBUTE, "])");
    var items = document.querySelectorAll(selectorWithoutMonitoredItems);
    if (items.length === 0) {
        return;
    }
    debug("[items] Number of tracked items: ".concat(items.length, "."));
    items.forEach(function (element) {
        if (element.hasAttribute(stateSwitch.config.items.attributeWithDopId)) {
            itemsIntersectionObserver.observe(element);
            element.setAttribute(ITEM_MONITORED_ATTRIBUTE, 'true');
        }
    });
    debug('[event] Items visibility event listeners have been added');
};
/**
 * Removes items visibilitychange event listener
 */
export var removeItemsVisibilityEventListeners = function () {
    var selectorMonitoredItems = stateSwitch.config.items.selector + "[".concat(ITEM_MONITORED_ATTRIBUTE, "]");
    var items = document.querySelectorAll(selectorMonitoredItems);
    items.forEach(function (element) {
        itemsIntersectionObserver.unobserve(element);
        element.removeAttribute(ITEM_MONITORED_ATTRIBUTE);
    });
    itemsIntersectionObserver = null;
    debug('[event] Items visibility event listeners have been disabled');
};
